<div *ngIf="loading" class="loader-overlay">
    <mat-spinner></mat-spinner>
</div>